export default {
    error: {
        abort_403_message: 'การเข้าถึงถูกปฏิเสธ คุณอาจไม่มีสิทธิ์ที่เหมาะสมในการเข้าถึงหน้านี้',
        abort_403_text: 'ไม่มีสิทธิ์',
        abort_404_message: 'หน้าที่คุณกำลังมองหาอาจถูกลบ เปลี่ยนชื่อ หรือไม่พร้อมใช้งานชั่วคราว',
        abort_404_text: 'ไม่พบหน้า',
        something_went_wrong: 'เกิดข้อผิดพลาด!',
        required: {
            address_in_cambodia: 'ต้องระบุที่อยู่',
            email: 'ต้องระบุอีเมล',
            first_name: 'ต้องระบุชื่อ',
            gender: 'ต้องระบุเพศ',
            identity_date: 'ต้องระบุวันที่ออกบัตรประชาชน',
            identity_image_back: 'ต้องระบุรูปด้านหลังบัตรประชาชน',
            identity_image_front: 'ต้องระบุรูปด้านหน้าบัตรประชาชน',
            identity_issued_date: 'ต้องระบุวันที่ออกบัตรประชาชน',
            identity_number: 'ต้องระบุเลขบัตรประชาชน',
            last_name: 'ต้องระบุนามสกุล',
            nationality: 'ต้องระบุสัญชาติ',
            passport_image_front: 'ต้องระบุรูปด้านหน้าหนังสือเดินทาง',
            passport_image_back: 'ต้องระบุรูปด้านหลังหนังสือเดินทาง',
            passport_number: 'ต้องระบุเลขหนังสือเดินทาง',
            password: 'ต้องระบุรหัสผ่าน',
        },
        saving: 'เกิดข้อผิดพลาดในการบันทึก'
    },
    label: {
        about: "เกี่ยวกับเรา",
        action: "การดำเนินการ",
        add: "เพิ่ม",
        address: "ที่อยู่",
        address_in_cambodia: "ที่อยู่ในกัมพูชา",
        admin_dashboard: "แดชบอร์ดผู้ดูแลระบบ",
        agree_to: "ฉันยอมรับ",
        all: "ทั้งหมด",
        already_have_account: "มีบัญชีอยู่แล้ว? เข้าสู่ระบบ",
        amendment: "การแก้ไข",
        amendment_date: "ขอขยายวันที่",
        amendment_office: "ขอเปลี่ยนด่านชายแดน",
        amount: "จำนวนเงิน",
        app_dashboard: "แดชบอร์ดแอปพลิเคชัน",
        app_name: "e-Customs",
        application: "ใบสมัคร",
        application_report: "รายงานใบสมัคร",
        applications: "ใบสมัคร",
        approve: "อนุมัติ",
        approve_changed_border_gate: "อนุมัติการเปลี่ยนด่านชายแดน",
        approve_extended_date_of_entry: "อนุมัติการขยายวันที่เข้า",
        approve_extended_date_of_exit: "อนุมัติการขยายวันที่ออก",
        asterisk: "จำเป็น",
        attachment: "ไฟล์แนบ",
        back: "ย้อนกลับ",
        back_side: "ด้านหลัง",
        between: "ระหว่าง",
        border_pass_date: "วันที่ออกใบผ่านแดน",
        border_pass_number: "หมายเลขใบผ่านแดน",
        brand: "ยี่ห้อ",
        browse_your_device: "เรียกดูอุปกรณ์ของคุณ",
        by_user: "โดยผู้ใช้",
        change_border_gate_of_entry: "เปลี่ยนด่านเข้า",
        change_border_gate_of_exit: "เปลี่ยนด่านออก",
        change_image: "เปลี่ยนรูปภาพ",
        changed_at: "เปลี่ยนแปลงเมื่อ",
        choose: "เลือก",
        choose_document: "เลือกไฟล์",
        choose_driver: "เลือกคนขับ",
        choose_image: "เลือกรูปภาพ",
        choose_vehicle: "เลือกยานพาหนะ",
        city: "เมือง",
        close: "ปิด",
        code: "รหัส",
        collapse: "ยุบ",
        color: "สี",
        company_address: "ที่อยู่บริษัท",
        company_code: "รหัสบริษัท",
        company_information: "ข้อมูลบริษัท",
        company_name: "ชื่อบริษัท",
        confirm: "ยืนยัน",
        confirm_delete: "คุณแน่ใจหรือไม่ว่าต้องการลบ?",
        confirm_password: "ยืนยันรหัสผ่าน",
        contain: "ประกอบด้วย",
        create: "สร้าง",
        create_application: "สร้างใบสมัคร",
        created_at: "สร้างเมื่อ",
        criteria: "เกณฑ์",
        currency: "สกุลเงิน",
        customs_registration: "การลงทะเบียนศุลกากร",
        dashboard: "แดshบอร์ด",
        date: "วันที่",
        declaration: "ใบแจ้ง",
        declaration_chart: "แผนภูมิใบแจ้ง",
        declaration_status: "ใบสมัครของฉัน",
        declaration_status_today: "ใบสมัครของฉันวันนี้",
        declarations: "ใบแจ้ง",
        decline: "ปฏิเสธ",
        decline_changed_border_gate: "ปฏิเสธการเปลี่ยนด่านชายแดน",
        decline_extended_date_of_entry: "ปฏิเสธการขยายวันที่เข้า",
        decline_extended_date_of_exit: "ปฏิเสธการขยายวันที่ออก",
        delete: "ลบ",
        delete_success: "ลบสำเร็จ",
        deleted_at: "ลบเมื่อ",
        description: "คำอธิบาย",
        destination: "จุดหมายปลายทาง",
        destination_assess: "ประเมินจุดหมายปลายทาง",
        destination_change: "เปลี่ยนจุดหมายปลายทาง",
        destination_office_code: "รหัสสำนักงานจุดหมายปลายทาง",
        destination_office_date: "วันที่จุดหมายปลายทาง",
        destination_office_name: "สำนักงานจุดหมายปลายทาง",
        destination_assess_status: "สถานะการประเมินจุดหมายปลายทาง",
        document_size: "ขนาดเอกสารต้องน้อยกว่าหรือเท่ากับ 5MB",
        dont_have: "ไม่มี",
        download: "ดาวน์โหลด",
        driver: "คนขับ",
        driver_information: "ข้อมูลคนขับ",
        drivers: "คนขับ",
        driving_license: "ใบขับขี่",
        driving_license_image_back: "รูปด้านหลังใบขับขี่",
        driving_license_image_front: "รูปด้านหน้าใบขับขี่",
        driving_license_photo: "รูปใบขับขี่",
        edit: "แก้ไข",
        email: "อีเมล",
        empty_data: "ไม่มีข้อมูลที่จะแสดง",
        engine_number: "หมายเลขเครื่องยนต์",
        enrouting: "ระหว่างเดินทาง",
        entry: "เข้า",
        entry_date: "วันที่เข้า",
        entry_office_code: "รหัสสำนักงานเข้า",
        entry_office_name: "ชื่อสำนักงานเข้า",
        entry_vehicles: "ยานพาหนะเข้า",
        entry_vehicles_today: "ยานพาหนะเข้าวันนี้",
        equal: "เท่ากับ",
        exit: "ออก",
        exit_date: "วันที่ออก",
        exit_office_code: "รหัสสำนักงานออก",
        exit_office_name: "ชื่อสำนักงานออก",
        exit_vehicles: "ยานพาหนะออก",
        exit_vehicles_today: "ยานพาหนะออกวันนี้",
        expand: "ขยาย",
        expired_date: "วันหมดอายุ",
        extended_date_of_entry: "ขยายวันที่เข้า",
        extended_date_of_exit: "ขยายวันที่ออก",
        female: "หญิง",
        file_name: "ชื่อไฟล์",
        filter: "กรอง",
        first_name: "ชื่อ",
        forgot_password: "ลืมรหัสผ่าน?",
        frame_number: "หมายเลขตัวถัง",
        fraud: "การฉ้อโกง",
        from: "จาก",
        from_date: "จากวันที่",
        front_side: "ด้านหน้า",
        fullname: "ชื่อ-นามสกุล",
        gender: "เพศ",
        greater_than: "มากกว่า",
        greater_than_or_equal: "มากกว่าหรือเท่ากับ",
        guarantee_information: "ข้อมูลการค้ำประกัน",
        guarantee_information_invalid: "ข้อมูลการค้ำประกันไม่ถูกต้อง",
        have: "มี",
        having_passport: "มีหนังสือเดินทาง?",
        home: "หน้าหลัก",
        i_am_also_a_driver: "คุณเป็นคนขับด้วยหรือไม่?",
        i_am_also_driver: "ฉันเป็นคนขับด้วย",
        id: "ไอดี",
        identity_card: "บัตรประชาชน",
        identity_card_expired_date: "วันหมดอายุบัตรประชาชน",
        identity_card_photo: "รูปบัตรประชาชน",
        identity_date: "วันที่ออกบัตรประชาชน",
        identity_image_back: "รูปด้านหลังบัตรประชาชน",
        identity_image_front: "รูปด้านหน้าบัตรประชาชน",
        identity_number: "เลขบัตรประชาชน",
        image_back: "รูปด้านหลัง",
        image_front: "รูปด้านหน้า",
        image_size: "ขนาดรูปภาพต้องน้อยกว่าหรือเท่ากับ 2MB",
        input_information_invalid: "ข้อมูลที่ป้อนไม่ถูกต้อง",
        insurance_company_code: "รหัสบริษัทประกันภัย",
        insurance_company_name: "ชื่อบริษัทประกันภัย",
        insurance_date: "วันที่ประกันภัย",
        insurance_number: "หมายเลขประกันภัย",
        is_required: "จำเป็น",
        issued_date: "วันที่ออก",
        last_name: "นามสกุล",
        leave_page_subtitle: "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก!",
        leave_page_title: "คุณต้องการออกจากหน้านี้จริงหรือไม่?",
        length_of_stay: "ระยะเวลาการพำนัก",
        less_than: "น้อยกว่า",
        less_than_or_equal: "น้อยกว่าหรือเท่ากับ",
        list: "รายการ",
        loading: "กำลังดึงข้อมูล...",
        lodgement: "การยื่นเอกสาร",
        lodgement_assess: "ประเมินการยื่นเอกสาร",
        lodgement_assess_approve: "สำนักงานยื่นเอกสารอนุมัติ",
        lodgement_assess_reject: "สำนักงานยื่นเอกสารปฏิเสธ",
        lodgement_office_code: "รหัสสำนักงานยื่นเอกสาร",
        lodgement_office_date: "วันที่ยื่นเอกสาร",
        lodgement_office_name: "สำนักงานยื่นเอกสาร",
        lodgement_assess_status: "สถานะการประเมินการยื่นเอกสาร",
        login: "เข้าสู่ระบบ",
        login_description: "เข้าสู่ระบบเพื่อเริ่มเซสชันของคุณ",
        login_information: "ข้อมูลการเข้าสู่ระบบ",
        male: "ชาย",
        months: ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],
        more_info: "ข้อมูลเพิ่มเติม",
        my_profile: "โปรไฟล์ของฉัน",
        n0: "ลำดับ",
        name: "ชื่อ",
        nationality: "สัญชาติ",
        next: "ถัดไป",
        no: "ไม่",
        no_application: "คุณยังไม่มีใบสมัคร",
        no_data: "ไม่มีข้อมูลที่ตรงกับการค้นหาของคุณ",
        no_image: "ไม่มีรูปภาพ",
        no_overstay: "ไม่มีใบแจ้งพำนักเกินกำหนด",
        no_recently_declaration: "ไม่มีใบแจ้งล่าสุด",
        not_equal: "ไม่เท่ากับ",
        number: "หมายเลข",
        office: "สำนักงาน",
        office_code: "รหัสสำนักงาน",
        officer: "เจ้าหน้าที่",
        ok: "ตกลง",
        other: "เอกสารอื่นๆ",
        other_attachment_title: "ไฟล์แนบต้องเป็นไฟล์รูปภาพและมีขนาดน้อยกว่า 5 MB",
        other_document: "เอกสารอื่นๆ",
        other_file_criteria: "ประเภทไฟล์ที่อนุญาต: jpeg, png, jpg, pdf และขนาด: 10MB",
        other_information: "ข้อมูลอื่นๆ",
        over_stay_applications: "ใบแจ้งพำนักเกินกำหนด",
        overstay: "พำนักเกินกำหนด",
        owner: "เจ้าของ",
        owner_also_driver: "เจ้าของเป็นคนขับด้วย",
        owner_border_pass: "ใบผ่านแดนของเจ้าของ",
        owner_confirm: "คุณเป็นเจ้าของหรือไม่?",
        owner_information: "ข้อมูลเจ้าของ",
        owner_passport: "หนังสือเดินทางของเจ้าของ",
        passport: "หนังสือเดินทาง",
        passport_date: "วันที่หนังสือเดินทาง",
        passport_expired_date: "วันหมดอายุหนังสือเดินทาง",
        passport_image_back: "รูปด้านหลังหนังสือเดินทาง",
        passport_issued_date: "วันที่ออกหนังสือเดินทาง",
        passport_number: "เลขหนังสือเดินทาง",
        passport_photo: "รูปหนังสือเดินทาง",
        password: "รหัสผ่าน",
        password_confirmation: "ยืนยันรหัสผ่าน",
        penalize: "ลงโทษ",
        phone: "โทรศัพท์",
        plate_number: "หมายเลขทะเบียนรถ",
        print: "พิมพ์",
        profile: "โปรไฟล์",
        qrcode: "คิวอาร์โค้ด",
        reason: "เหตุผล",
        receipt_number: "หมายเลขใบเสร็จ",
        recent_declaration: "ใบแจ้งล่าสุด",
        register: "ลงทะเบียน",
        register_date: "วันที่ลงทะเบียน",
        register_new_account: "ลงทะเบียนบัญชีใหม่",
        register_number: "หมายเลขลงทะเบียน",
        register_type: "ประเภทการลงทะเบียน",
        register_year: "ปีที่ลงทะเบียน",
        reject: "ปฏิเสธ",
        reload: "โหลดใหม่",
        remove: "ลบออก",
        report: "รายงาน",
        request_change: "ขอเปลี่ยนแปลง",
        request_change_entry_date: "ขอเปลี่ยนวันที่เข้า",
        request_change_entry_office: "ขอเปลี่ยนสำนักงานเข้า",
        request_change_exit_date: "ขอเปลี่ยนวันที่ออก",
        request_change_exit_office: "ขอเปลี่ยนสำนักงานออก",
        request_changed_border_gate: "ขอเปลี่ยนด่านชายแดน",
        request_extended_date_of_entry: "ขอขยายวันที่เข้า",
        request_extended_date_of_exit: "ขอขยายวันที่ออก",
        reset_password: "รีเซ็ตรหัสผ่านของคุณ",
        resolve: "แก้ไข",
        restore: "กู้คืน",
        result: "ผลลัพธ์",
        return_home: "กลับหน้าหลัก",
        save: "บันทึก",
        save_continue: "บันทึกและดำเนินการต่อ",
        scan: "สแกน",
        search: "ค้นหา",
        search_application: "ค้นหาใบสมัคร",
        search_driver: "ค้นหาคนขับ",
        search_not_found: "ไม่พบใบสมัคร",
        search_vehicle: "ค้นหายานพาหนะ",
        security_returned: "การค้ำประกันนี้ถูกคืนแล้ว",
        select: "เลือก",
        select_driver: "กรุณาเลือกคนขับ",
        select_vehicle: "กรุณาเลือกยานพาหนะ",
        send: "ส่ง",
        serial: "ซีเรียล",
        setting: "การตั้งค่า",
        setup_my_profile: "ตั้งค่าโปรไฟล์ของฉัน",
        sign_in: "เข้าสู่ระบบ",
        size: "ขนาด",
        status: "สถานะ",
        steer: "พวงมาลัย",
        submit: "ส่ง",
        temporary_export: "ส่งออกชั่วคราว",
        temporary_import: "นำเข้าชั่วคราว",
        temporary_vehicle: "ยานพาหนะชั่วคราว",
        terms_conditions: "ข้อกำหนดและเงื่อนไข",
        timeline: "ไทม์ไลน์",
        to: "ถึง",
        to_date: "ถึง",
        today_entry: "เข้าวันนี้",
        today_exit: "ออกวันนี้",
        total_declaration: "ใบแจ้งทั้งหมด",
        total_vehicle: "ยานพาหนะทั้งหมด",
        type: "ประเภท",
        update: "อัปเดต",
        update_profile: "อัปเดตโปรไฟล์",
        updated_at: "อัปเดตเมื่อ",
        valid_from: "มีผลตั้งแต่",
        valid_to: "มีผลถึง",
        value_1: "ค่าที่ 1",
        value_2: "ค่าที่ 2",
        vehicle: "ยานพาหนะ",
        vehicle_and_driver: "ยานพาหนะและคนขับ",
        vehicle_chart: "แผนภูมิยานพาหนะ",
        vehicle_identitation_back: "รูปด้านหลังเอกสารยานพาหนะ",
        vehicle_identitation_front: "รูปด้านหน้าเอกสารยานพาหนะ",
        vehicle_identity_photo: "รูปเอกสารยานพาหนะ",
        vehicle_information: "ข้อมูลยานพาหนะ",
        vehicle_report: "รายงานยานพาหนะ",
        vehicle_type: "ประเภทยานพาหนะ",
        vehicles: "ยานพาหนะ",
        view: "ดู",
        view_attachment: "ดูไฟล์แนบ",
        view_detail: "ดูรายละเอียด",
        view_document: "ดูเอกสาร",
        view_image: "ดูรูปภาพ",
        year: "ปี",
        yes: "ใช่",
        your_email: "อีเมลของคุณ",
        your_information: "ข้อมูลของคุณ",
        your_password: "รหัสผ่านของคุณ",
        zip: "รหัสไปรษณีย์",
        pending: "รอดำเนินการ",
        edit_detail: "แก้ไขรายละเอียด",
        owners: "เจ้าของ",
        search_owner: "ค้นหาเจ้าของ",
        choose_owner: "เลือกเจ้าของ",
        select_owner: "กรุณาเลือกเจ้าของ",
        declined: "ปฏิเสธแล้ว",
        destination_approved: 'สำนักงานจุดหมายปลายทางอนุมัติแล้ว',
    },
    message: {
        already_declaration: "แจ้งไปแล้ว!",
        approve_amendment: "คุณต้องการอนุมัติคำขอนี้หรือไม่?",
        click_to_view: "คลิกเพื่อดูไฟล์แนบ",
        decline_amendment: "คุณต้องการปฏิเสธคำขอนี้หรือไม่?",
        instruction_info: "กรุณาคลิกที่ปุ่มตกลง ระบบจะพาคุณไปกรอกข้อมูลให้สมบูรณ์",
        no_driver: "คุณยังไม่มีข้อมูลคนขับ!",
        no_result: "ไม่มีผลลัพธ์!",
        no_vehicle: "คุณยังไม่มีข้อมูลยานพาหนะ!",
        not_update_passport: "คุณยังไม่ได้กรอกข้อมูลหนังสือเดินทางให้สมบูรณ์!",
        not_update_profile: "คุณยังไม่ได้อัปเดตโปรไฟล์!",
        profile_completion_message: "โปรไฟล์ของคุณยังไม่สมบูรณ์สำหรับการสมัคร กรุณาตั้งค่าโปรไฟล์ของคุณ!",
        profile_completion_title: "แจ้งเตือน!",
        profile_success: "บันทึกโปรไฟล์สำเร็จ!",
        required_if_no_identity_card: "ข้อมูลนี้จะต้องระบุหากไม่มีบัตรประชาชน",
        required_if_no_passport: "ข้อมูลนี้จะต้องระบุหากไม่มีหนังสือเดินทาง",
        success: "บันทึกเอกสารสำเร็จ!",
        verify_phone: "เราจะยืนยันบัญชีของคุณด้วยหมายเลขโทรศัพท์นี้ กรุณาตรวจสอบว่าถูกต้อง",
        please_complete_declaration_owner_first: 'กรุณากรอกข้อมูลเจ้าของให้สมบูรณ์ก่อน!',
        owner_success: "บันทึกเจ้าของสำเร็จ!",
        driver_success: "บันทึกคนขับสำเร็จ!",
        vehicle_success: "บันทึกยานพาหนะสำเร็จ!",
    },
    validation: {
        attributes: {
            address: "ที่อยู่",
            address_in_cambodia: "ที่อยู่ในกัมพูชา",
            attachment: "ไฟล์แนบ",
            border_pass_date: "วันที่ใบผ่านแดน",
            border_pass_number: "หมายเลขใบผ่านแดน",
            owner_border_pass_number: "หมายเลขใบผ่านแดน",
            brand: "ยี่ห้อ",
            color: "สี",
            company_code_v1: "รหัสบริษัท",
            destination_entry_date: "วันที่เข้า",
            destination_entry_office_name: "ชื่อสำนักงานเข้า",
            destination_exit_date: "วันที่ออก",
            destination_exit_office_name: "ชื่อสำนักงานออก",
            destination_office_code_v1: "รหัสสำนักงานจุดหมายปลายทาง",
            destination_office_date_v1: "วันที่สำนักงานจุดหมายปลายทาง",
            destination_office_date_v2: "วันที่สำนักงานจุดหมายปลายทาง",
            driver_address_in_cambodia: "ที่อยู่ในกัมพูชา",
            driver_border_pass_date: "วันที่ใบผ่านแดน",
            driver_border_pass_number: "หมายเลขใบผ่านแดน",
            driver_first_name: "ชื่อ",
            driver_gender: "เพศ",
            driver_last_name: "นามสกุล",
            driver_nationality: "สัญชาติ",
            driver_passport_expired_date: "วันหมดอายุหนังสือเดินทาง",
            driver_passport_issued_date: "วันที่ออกหนังสือเดินทาง",
            driver_passport_number: "เลขหนังสือเดินทาง",
            driving_license_image_back: "รูปด้านหลังใบขับขี่",
            driving_license_image_front: "รูปด้านหน้าใบขับขี่",
            engine_number: "หมายเลขเครื่องยนต์",
            entry_date: "วันที่เข้า",
            entry_office_name: "ชื่อสำนักงานเข้า",
            exit_date: "วันที่ออก",
            exit_office_name: "ชื่อสำนักงานออก",
            first_name: "ชื่อ",
            frame_number: "หมายเลขตัวถัง",
            fraud_code: "รหัสการฉ้อโกง",
            fraud_name: "ชื่อการฉ้อโกง",
            fraud_valid_from: "การฉ้อโกงมีผลตั้งแต่",
            fraud_valid_to: "การฉ้อโกงมีผลถึง",
            from_date: "จากวันที่",
            full_name: "ชื่อ-นามสกุล",
            fullname: "ชื่อ-นามสกุล",
            fullname_v1: "ชื่อ-นามสกุล",
            gender: "เพศ",
            gender_v1: "เพศ",
            identity_date: "วันที่บัตรประชาชน",
            identity_date_expire: "วันหมดอายุบัตรประชาชน",
            identity_image_back: "รูปด้านหลังบัตรประชาชน",
            identity_image_front: "รูปด้านหน้าบัตรประชาชน",
            identity_number: "เลขบัตรประชาชน",
            identity_v1: "บัตรประชาชน",
            insurance_company_code: "รหัสบริษัทประกันภัย",
            insurance_company_name: "ชื่อบริษัทประกันภัย",
            insurance_date: "วันที่ประกันภัย",
            insurance_number: "หมายเลขประกันภัย",
            last_name: "นามสกุล",
            lodgement_office_code_v1: "รหัสสำนักงานยื่นเอกสาร",
            lodgement_office_date_v1: "วันที่สำนักงานยื่นเอกสาร",
            lodgement_office_date_v2: "วันที่สำนักงานยื่นเอกสาร",
            nationality: "สัญชาติ",
            nationality_v1: "สัญชาติ",
            office_code: "รหัสสำนักงาน",
            other: "เอกสารอื่นๆ",
            owner_border_pass_date: "วันที่ใบผ่านแดน",
            owner_border_pass_v1: "ใบผ่านแดนของเจ้าของ",
            owner_passport_number: "เลขหนังสือเดินทางของเจ้าของ",
            owner_passport_v1: "หนังสือเดินทางของเจ้าของ",
            passport_expired_date: "วันหมดอายุหนังสือเดินทาง",
            passport_image_back: "รูปด้านหลังหนังสือเดินทาง",
            passport_image_front: "รูปด้านหน้าหนังสือเดินทาง",
            passport_issued_date: "วันที่ออกหนังสือเดินทาง",
            passport_number: "เลขหนังสือเดินทาง",
            passport_v1: "หนังสือเดินทาง",
            plate_number: "หมายเลขทะเบียนรถ",
            profile_address: "ที่อยู่",
            profile_driving_license_image_back: "รูปด้านหลังใบขับขี่",
            profile_driving_license_image_front: "รูปด้านหน้าใบขับขี่",
            profile_first_name: "ชื่อ",
            profile_gender: "เพศ",
            profile_identity_date: "วันที่บัตรประชาชน",
            profile_identity_date_expire: "วันหมดอายุบัตรประชาชน",
            profile_identity_image_back: "รูปด้านหลังบัตรประชาชน",
            profile_identity_image_front: "รูปด้านหน้าบัตรประชาชน",
            profile_identity_number: "เลขบัตรประชาชน",
            profile_last_name: "นามสกุล",
            profile_nationality: "สัญชาติ",
            profile_passport_image_back: "รูปด้านหลังหนังสือเดินทาง",
            profile_passport_image_front: "รูปด้านหน้าหนังสือเดินทาง",
            register_type: "ประเภทการลงทะเบียน",
            registration_date_v1: "วันที่ลงทะเบียน",
            registration_date_v2: "วันที่ลงทะเบียน",
            registration_number: "หมายเลขลงทะเบียน",
            registration_number_v1: "หมายเลขลงทะเบียน",
            registration_number_v2: "หมายเลขลงทะเบียน",
            registration_type: "ประเภท",
            registration_type_v1: "ประเภท",
            registration_year_v1: "ปีที่ลงทะเบียน",
            registration_year_v2: "ปีที่ลงทะเบียน",
            request_change_description: "คำอธิบายคำขอเปลี่ยนแปลง",
            request_change_description2: "คำอธิบายคำขอเปลี่ยนแปลง",
            security_date: "วันที่ค้ำประกัน",
            security_number: "หมายเลขใบเสร็จ",
            security_office: "สำนักงานค้ำประกัน",
            security_serial: "ซีเรียลค้ำประกัน",
            steer: "พวงมาลัย",
            to_date: "ถึงวันที่",
            type: "ประเภท",
            vehicle_type: "ประเภท",
            verify_amend_description: "คำอธิบาย",
            year: "ปี"
        }
    }
}